/* LNL 2026-11-03: MakeCommerce „Cart selection“ – be pasirinkto pristatymo būdo ir atsiėmimo punkto Shopify atsiskaityme nerodo jokio siuntimo. Neleidžiame pereiti prie atsiskaitymo, kol nepasirinkta. */
(function(){
  function msg(){ return (window.lnlMcStrings && window.lnlMcStrings.choose) || 'Pasirinkite pristatymo būdą ir atsiėmimo punktą.'; }
  function valid(w){
    var d = w.querySelector('.mc-delivery-btn.active');
    if (!d) return false;
    var pm = document.getElementById('mc-parcel-machines');
    var pickup = pm && !pm.classList.contains('hidden-element') && pm.offsetParent !== null;
    if (pickup) {
      var s = document.getElementById('mk-address-select');
      if (!s || !s.value) return false;
    }
    return true;
  }
  document.addEventListener('click', function(){
    setTimeout(function(){ var w = document.getElementById('mc-shipping-wrapper'); var n = document.getElementById('lnl-mc-warn'); if (w && n && valid(w)) n.remove(); }, 400);
  });
  document.addEventListener('change', function(){
    setTimeout(function(){ var w = document.getElementById('mc-shipping-wrapper'); var n = document.getElementById('lnl-mc-warn'); if (w && n && valid(w)) n.remove(); }, 400);
  });
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
    if (!b) return;
    var w = document.getElementById('mc-shipping-wrapper');
    if (!w) { if (!/\/cart(\?|$)/.test(location.pathname)) { e.preventDefault(); location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; } return; }
    if (valid(w)) return;
    e.preventDefault(); e.stopPropagation();
    var n = document.getElementById('lnl-mc-warn');
    if (!n) { n = document.createElement('p'); n.id = 'lnl-mc-warn'; n.setAttribute('role','alert'); n.style.cssText = 'color:#b42318;font-weight:600;margin:.8rem 0;'; w.appendChild(n); }
    n.textContent = msg();
    w.scrollIntoView({behavior:'smooth', block:'center'});
  }, true);
})();
